import _get from 'lodash/get';
import React, { Fragment, useCallback, useMemo, useState } from 'react';
import * as Schema from '../types/schema';

interface ContextValue {
	reccomended: Schema.Field[];
	onReccomended?: (field: Schema.Field) => void;
}

export const AppContext = React.createContext<ContextValue>({
	reccomended: [],
});

function AppProvider(props: any) {
	const [reccomended, setReccomended] = useState<Schema.Field[]>([]);

	const onReccomended = useCallback((field: Schema.Field) => {
		setReccomended((state) => (state.map((f) => f.name).includes(field.name) ? [...state] : [...state, field]));
	}, []);

	return (
		<AppContext.Provider
			value={{
				reccomended,
				onReccomended,
			}}
		>
			{props.children}
		</AppContext.Provider>
	);
}

export default AppProvider;
